module.exports = __webpack_public_path__ + "static/media/plane.6fda5aba.jpg";